import { Collection } from '../types/database.type';

export interface FormTemplateData<T extends string> {
  id: string;
  name: string;
  /** named fields with template as value */
  texts: TemplateTexts<T>;
  mergeFields: TemplateMergeFields;
}
export type TemplateMergeFields = Collection<MergeField>;
export type TemplateTexts<T extends string> = Record<T, string>;

export interface MergeField {
  id: string;
  type: MergeFieldType;
  label: string;
}

export enum MergeFieldType {
  DATE = 'date',
  DATE_TIME = 'dateTime',
  TIME = 'time',
  NUMBER = 'number',
  TEXT = 'text'
}

export enum FormTemplateType {
  SMS = 'sms',
  NEWS = 'news'
}
